// eslint-disable-next-line no-undef
module.exports = [
  {
    subjectId: '0f10f310-6b2a-4916-9e28-3e1e07ca73bb',
    subjectInfo: {
      subjectName: 'COMPUTER ORGANISATION',
      description: 'COMPUTER ORGANISATION',
    },
    imagePath: '',
    subjectState: 'PUBLISHED',
  },
  {
    subjectId: '189ecc2c-b907-44cc-81f1-b603478df052',
    subjectInfo: {
      subjectName: 'Standards & Quality',
      description:
        'Standards and Quality Practices are an important part of all sectors. UPSC have included it in IES syllabus by keeping in mind broader prospective for its upcoming Engineering Professional. In this course we will try to understand what are Standard and Quality Practices in various sectors like Production Construction Maintenance and Services. Our approach will be Managerial along with technical.',
    },
    imagePath:
      'https://d34t1fpu6lon2w.cloudfront.net/UI/unit-1/topic-1/subtopic-1/images/four.jpeg',
    subjectState: 'PUBLISHED',
  },
  {
    subjectId: '1a71245b-9655-4b27-bd71-c0c15e3df03f',
    subjectInfo: {
      subjectName: 'subject-2',
      description: 'description',
    },
    imagePath: '',
    subjectState: 'PUBLISHED',
  },
  {
    subjectId: '38a9280e-1bfd-4f34-96dc-02a9d18c098d',
    subjectInfo: {
      subjectName: 'subject-1',
      description: 'description',
    },
    imagePath: '',
    subjectState: 'PUBLISHED',
  },
  {
    subjectId: '41195a9a-375a-496c-9f67-d5b5ee1b5745',
    subjectInfo: {
      subjectName: 'test-subject',
      description: 'descruption',
    },
    imagePath: '',
    subjectState: 'PUBLISHED',
  },
  {
    subjectId: '6337e028-21d8-41bb-a194-247dc029233b',
    subjectInfo: {
      subjectName: 'Create-1',
      description: 'creating subject',
    },
    imagePath: '',
    subjectState: 'PUBLISHED',
  },
  {
    subjectId: '7a8365db-fd8e-4df4-a8d0-7b55b25f105a',
    subjectInfo: {
      subjectName: 'Ethics & Values',
      description:
        'Personal values are personal beliefs about right and wrong and may or may not be considered moral. Cultural values are values accepted by religions or societies and reflect what is important in each context. Values are essential to ethics. Ethics is concerned with human actions, and the choice of those actions',
    },
    imagePath:
      'https://d34t1fpu6lon2w.cloudfront.net/UI/unit-1/topic-1/subtopic-1/images/four.jpeg',
    subjectState: 'PUBLISHED',
  },
  {
    subjectId: '8fd15524-e994-47e7-a93e-731eaeb9831b',
    subjectInfo: {
      subjectName: 'subjectss',
      description: 'description',
    },
    imagePath: '',
    subjectState: 'PUBLISHED',
  },
  {
    subjectId: 'b6cbe5db-b47c-41ac-a4d7-04b076ae773e',
    subjectInfo: {
      subjectName: 'Quiz subject',
      description: 'quizzes',
    },
    imagePath: '',
    subjectState: 'PUBLISHED',
  },
  {
    subjectId: 'c863ec3b-8fc6-42a2-8bf1-39e25a1b8c3a',
    subjectInfo: {
      subjectName: 'subjjject',
      description: 'subject description',
    },
    imagePath: '',
    subjectState: 'PUBLISHED',
  },
  {
    subjectId: 'd1b30aee-735d-485e-9e4f-ad5ce5a11e8d',
    subjectInfo: {
      subjectName: 'Energy & Environment',
      description:
        'Energy & Environment is an interdisciplinary journal inviting energy policy analysts, natural scientists and engineers, as well as lawyers and economists to contribute to mutual understanding and learning. The rapidly evolving social and environmental impacts of energy supply, transport, production and...',
    },
    imagePath: '',
    subjectState: 'PUBLISHED',
  },
  {
    subjectId: 'd3f2c425-8237-46fc-84d7-9e0c1db54bdc',
    subjectInfo: {
      subjectName: 'testSubject-1',
      description: 'testing subject description',
    },
    imagePath: '',
    subjectState: 'PUBLISHED',
  },
  {
    subjectId: '5945ae75-87f9-428e-b08c-2c9c0f26f6e8',
    subjectInfo: {
      subjectName: 'Test',
      description: 'Test',
    },
    imagePath: '',
    subjectState: 'PUBLISHED',
  },
];
